module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"title":"SIG jest zainteresowany zakupem projektów, które do 3 grudnia 2020 roku uzyskają:","items":[{"text":"Warunki przyłączenia do sieci"},{"text":"Pozwolenie na budowę"},{"text":"Zaświadczenie o dopuszczeniu do aukcji"}]}}')
  delete Component.options._Ctor
}
